<div class="card kpi-success">
    <div class="card-body kpi-card">
        <h5 class="card-title">Total travaux</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €</ng-container>
            <ng-container *ngIf="!preview">
                {{ (favorite.works_total + favorite.other_fees_work) | number:'1.0-0'}} €
            </ng-container>
        </p>
    </div>
</div>
